import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'alt_confirmation';
export const route = 'alt_confirmation/[[...token]]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "alt_confirmation" */
/* webpackPrefetch: true */
'../components/AltConfirmationPage')));